import React from 'react';
import About from './component/About';
import Projects from './component/Projects';
import Menu from './component/Menu';
import Skills from './component/Skills';
import Contact from './component/Contact';

export default function App() {
    return (
        <main className="text-gray-400 bg-gray-900 body-font">
            <Menu />
            <About />
            <Projects/>
            <Skills />
            <Contact />
        </main>
    );
}



// WEBPACK FOOTER //
// ./src/App.js